<!--
 * @Description: 大亚湾定制化三维中心Header
-->
<template>
  <div
    class="
      flex
      justify-items-center
      items-center
      bg-cover bg-no-repeat
      cockpit-header
      h-100px
      absolute
      -top-1px
      w-full
      -right-0px
    "
  >
    <!-- 左侧logo -->
    <div class="leading-55px h-full relative flex flex-row-1">
      <img
        class="ml-10px mt-10px w-310px h-34px cursor-pointer z-1 relative"
        :src="cockpitLogoUrl"
        alt=""
      />
    </div>
    <div
      class="
        text-44px
        justify-center
        items-center
        flex flex-row-1
        text-[#fff]
        cockpit-header__mid
        h-50px
        relative
        cursor-pointer
        w-480px
      "
      @click="changeModule(homeComponent)"
    >
      <span class="leading-100px cursor-pointer truncate">{{
        homeComponent.name || "三维可视化运营中心"
      }}</span>
    </div>
    <!-- 右侧操作 -->
    <div class="h-full flex flex-row-1 items-start justify-end mt-20px">
      <div class="h-100px flex justify-between items-start">
        <div
          class="
            cockpit-header__right-time
            text-[#41DAD4]
            flex flex-row
            items-center
            justify-center
          "
        >
          <div class="text-28px w-140px">{{ currentTime }}</div>
          <div class="text-20px">{{ currentDate }}</div>
        </div>
        <div class="pr-4px -left-1px flex items-start ml-20px">
          <el-tooltip content="报警" placement="top" effect="dark">
            <el-badge :max="99" :value="alarmNum" :hidden="alarmNum <= 0" class="alarm-number">
              <img
                class="mr-10px inline-block w-30px h-30px cursor-pointer"
                src="../../assets/images/header/danger.png"
                alt
                @click="$emit('openAlarmListDyw')"
              />
            </el-badge>
          </el-tooltip>
          <el-tooltip content="管理台" placement="top" effect="dark">
            <img
              class="mr-10px inline-block w-30px h-30px cursor-pointer"
              src="../../assets/images/header/home.png"
              alt=""
              @click="toHomePage()"
            />
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  SectionApi,
  SchemeApi,
  ThreeDimensionalAlarmCenterApi,
} from '@wiz-api/cloud-render-management'
import { FileApi } from '@wiz-api/file-management'

const fileApi = new FileApi()
const sectionApi = new SectionApi()
const schemeApi = new SchemeApi()
const alarmCenterApi = new ThreeDimensionalAlarmCenterApi()

export default {
  name: 'CockpitHeader',
  props: {
    defaultSection: {
      type: String,
      default: '',
    },
    alarmJumpSection: {
      type: Object,
      default: () => {},
    },
    loadModelStatus: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    defaultSection(val) {
      this.setDefalutSection()
    },
    alarmJumpSection(val) {
      this.changeModule(val)
    },
  },
  data() {
    return {
      imgIndex: 0,
      rightComponents: [],
      homeComponent: {},
      // 当前选中的板块
      checkedSection: '',
      // 默认激活的模式
      mode: 'cockpit',
      totalComponents: [],
      cockpitLogoUrl: '',
      currentTime: null,
      currentDate: null,
      alarmNum: 0, // 当日报警数
      getAlarmTimer: null, // 获取当日报警定时器标识
    }
  },
  async created() {
    if (this.$route.query.mode) {
      this.toggleMode(this.$route.query.mode)
    }
    // 获取板块列表
    await this.getSectionList()
    // 获取当日报警总数
    this.getTodayAlarmNum()
    this.getAlarmTimer = setInterval(() => {
      this.getTodayAlarmNum()
    }, 5000)
    // 默认加载
    this.setDefalutSection()
  },
  mounted() {
    this.getCurrenTime()
    setInterval(() => {
      this.getCurrenTime()
    }, 1000)
  },
  methods: {
    getCurrenTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = (now.getMonth() + 1).toString().padStart(2, '0')
      const day = now
        .getDate()
        .toString()
        .padStart(2, '0')
      const hour = now
        .getHours()
        .toString()
        .padStart(2, '0')
      const minute = now
        .getMinutes()
        .toString()
        .padStart(2, '0')
      const second = now
        .getSeconds()
        .toString()
        .padStart(2, '0')
      this.currentTime = `${hour}:${minute}:${second}`
      this.currentDate = `${year}.${month}.${day}`
    },
    setDefalutSection() {
      const currentItem = _.find(this.totalComponents, [
        'functionLocationType',
        Number(this.defaultSection),
      ])
      if (currentItem) {
        this.changeModule(currentItem, true)
      }
    },
    // 获取logo图片
    async getLogoContent(id) {
      const [fileErr, fileRes] = await fileApi.getFileContent(id)
      if (!fileErr) {
        this.cockpitLogoUrl = `data:image/jpg;base64,${fileRes.content}`
      }
    },
    /**
     * @description: 获取模块列表
     * @return {*}
     */

    async getSectionList() {
      // 获取当前用户加载方案
      const keyword = _.get(this.$route, 'query.programmeCode')
      // 未匹配当前用户设置方案，使用默认方案
      const params = _.omit(
        {
          keyword,
          isEnable: true,
          maxResultCount: 1,
          skipCount: 0,
        },
        keyword ? 'isEnable' : 'name'
      )
      const [errScheme, resScheme] = await schemeApi.getList(params)
      const currentProgrammeId = _.get(_.head(resScheme.items), 'id')
      // 不存在匹配项，跳出模块获取
      if (!currentProgrammeId) {
        return
      }
      if (_.get(_.head(resScheme.items), 'logo')) {
        this.getLogoContent(_.get(_.head(resScheme.items), 'logo'))
      }
      const [err, res] = await sectionApi.getList({ schemeId: currentProgrammeId })
      if (!err && res && res.items) {
        this.totalComponents = res.items
        _.forEach(res.items, (item) => {
          if (item.functionLocationType === 5) {
            this.homeComponent = item
            localStorage.setItem('sceneId', item.sceneId)
          } else {
            this.rightComponents.push(item)
          }
        })
        this.rightComponents = _.sortBy(this.rightComponents, 'functionLocationType')
      }
    },
    changeModule(moduleItem, defalut = false) {
      if (moduleItem === 'smart-map') {
        this.$router.push('/cockpit-hz/cockpit-index/smart-map')
        this.imgIndex = 1
        this.checkedSection = ''
        return
      }
      if (!this.loadModelStatus && !defalut) {
        this.$message.warning('模型加载中，请稍后...')
        return
      }
      if (moduleItem) {
        this.imgIndex = 0
        this.checkedSection = moduleItem.functionLocationType
        this.$emit('changeModule', moduleItem)
      }
    },
    toggleMode(mode) {
      this.mode = mode
      this.$emit('toggleMode', mode)
    },
    /**
     * 回到主页
     */
    toHomePage() {
      const defaultPath = this.$store.getters['Auth/defaultPath']
      const menuList = this.$store.getters['Auth/menuList']
      // 过滤掉驾驶舱页面
      if (defaultPath && !defaultPath.startsWith('/cockpit')) {
        this.$router.push(defaultPath)
      } else if (_.isEmpty(menuList)) {
        this.$router.push('/')
      } else {
        // 跳转至第一个模块
        const path = this.getFirstPage(menuList)
        this.$router.push(path || '/')
      }
    },
    getFirstPage(menuList) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < menuList.length; i++) {
        const menuItem = menuList[i]
        let path = null
        if (menuItem.children && menuItem.children.length) {
          path = this.getFirstPage(menuItem.children)
        } else {
          path = menuItem.index
        }
        // 模块不为第三方地址时跳转且不为驾驶舱页面
        if (path && path.startsWith('/') && !path.startsWith('/cockpit')) {
          return path
        }
      }
      return null
    },
    // 获取当日报警总数
    async getTodayAlarmNum() {
      const [err, res] = await alarmCenterApi.getToDayAlarmCount()
      if (!err && !_.isNil(res)) {
        this.alarmNum = res
      }
    },
  },
  beforeDestroy() {
    // 清除获取报警总数的定时器
    if (this.getAlarmTimer) {
      clearInterval(this.getAlarmTimer)
    }
  },
}
</script>

<style lang="scss" scoped>
.cockpit-header {
  background: url('../../assets/images/header/header_bg3.png');
  background-size: 100% 100%;

  &__mid {
    font-family: PangMenZhengDaoTitleBody;
  }

  &__right {
    width: calc(100% - 750px);

    &-time {
      font-family: PangMenZhengDaoTitleBody;
    }
  }

  &-module {
    &__title {
      line-height: 30px !important;
    }

    &__right {
      background-image: url('../../assets/images/header/top_button_default.png');
      background-size: 100% 100%;

      &-checked {
        background-image: url('../../assets/images/header/top_button_active.png');
        background-size: 100% 100%;
      }
    }
  }
}

.alarm-number {
  ::v-deep .el-badge__content.is-fixed {
    right: 30px;
  }
}
</style>
